import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface FloatingActionsContextType {
  showFloatingActions: boolean;
}

const FloatingActionsContext = createContext<FloatingActionsContextType | undefined>(undefined);

export const useFloatingActions = () => {
  const context = useContext(FloatingActionsContext);
  if (!context) {
    throw new Error('useFloatingActions must be used within a FloatingActionsProvider');
  }
  return context;
};

interface FloatingActionsProviderProps {
  children: ReactNode;
}

export const FloatingActionsProvider = ({ children }: FloatingActionsProviderProps) => {
  const [showFloatingActions, setShowFloatingActions] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    const handleScroll = () => {
      // Show floating actions after scrolling down a full viewport height
      const viewportHeight = window.innerHeight;
      setShowFloatingActions(window.scrollY > viewportHeight);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <FloatingActionsContext.Provider value={{ showFloatingActions }}>
      {children}
    </FloatingActionsContext.Provider>
  );
};